import { render, staticRenderFns } from "./JurisdiccionCombobox.vue?vue&type=template&id=04f8dc3a&scoped=true"
import script from "./JurisdiccionCombobox.vue?vue&type=script&lang=js"
export * from "./JurisdiccionCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8dc3a",
  null
  
)

export default component.exports